import { Component, OnInit, AfterViewInit, Input, HostListener } from '@angular/core';

@Component({
  selector: 'team-carousel',
  templateUrl: './team-carousel.component.html',
  styleUrls: ['./team-carousel.component.sass']
})
export class TeamCarouselComponent implements OnInit, AfterViewInit {

  @Input() members: any[];
  @Input() showControls: boolean;
  @Input() showEmails = true;
  @Input() specificEmail = true;

  private memberList: HTMLCollectionOf<Element> = document.getElementsByClassName('memberselector');
  private oldIndex: number = undefined;

  template_value: any = null;

  constructor() { }

  ngOnInit() {
    // screen size value
    this.detectTemplate(window.innerWidth);
  }

  ngAfterViewInit() {
    let _i;
    for (let i = 0; i < this.members.length; i++) {

      if (this.memberList[i].classList.contains('active')) {
        _i = i;
      }
    }
    this.setTemplate(_i);
  }

  @HostListener('window:resize', ['$event']) onScreenResize(event) {
    this.detectTemplate(event.target.innerWidth);
    let _i;
    for (let i = 0; i < this.members.length; i++) {
      if (this.memberList[i].classList.contains('active')) {
        _i = i;
      }
    }
    this.setTemplate(_i);
  }

  public filterBy(prop: string) {
    return this.members.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }

  private activateSlide(_selectedMember): void {
    this.oldIndex = undefined;
    let increaseBy = 0;
    let decreaseBy = 0; // let direction: string = '';

    if (!_selectedMember.isActive) {

      for (let i = 0; i < this.members.length; i++) {
        // find the active item
        if (this.memberList[i].classList.contains('active')) {
          // deactivate it
          this.memberList[i].classList.remove('active');
          // and store the index
          this.oldIndex = i;
        }
      }

      this.members[this.oldIndex].isActive = false;
      _selectedMember.isActive = true;

      if (_selectedMember.index > this.members[this.oldIndex].index) {
        if (this.template_value != '3' && this.memberList.length <= 7) {
          increaseBy = _selectedMember.index - this.members[this.oldIndex].index;
          // re-index items
          for (let i = 0; i < increaseBy; i++) {
            this.next(false);
          }
        } else if (this.memberList.length > 7) {
          increaseBy = _selectedMember.index - this.members[this.oldIndex].index;
          // re-index items
          for (let i = 0; i < increaseBy; i++) {
            this.next(false, increaseBy);
          }
        } else {
          this.next(true);
        }
        // or decrease
      } else if (_selectedMember.index < this.members[this.oldIndex].index) {
        if (this.template_value !== '3' && this.memberList.length <= 7) {
          decreaseBy = this.members[this.oldIndex].index - _selectedMember.index;
          // re-index items
          for (let i = 0; i < decreaseBy; i++) {
            this.prev(false);
          }
        } else if (this.memberList.length > 7) {
          decreaseBy = this.members[this.oldIndex].index - _selectedMember.index;
          // re-index items
          for (let i = 0; i < decreaseBy; i++) {
            this.prev(false, decreaseBy);
          }
        } else {
          this.prev(true);
        }
      }
    }
  }

  public next(_arrowClick: boolean, _increment?: number) {
    if (this.template_value != '3' && this.memberList.length <= 7) {
      this.oldIndex = undefined;
    }

    if (_arrowClick) {
      for (let i = 0; i < this.members.length; i++) {
        // find the active item
        if (this.memberList[i].classList.contains('active')) {
          // deactivate it
          this.memberList[i].classList.remove('active');
          // and store the index
          this.oldIndex = i;
        }
      }

      // deactivate previous
      this.members[this.oldIndex].isActive = false;
      // activate the selected
      this.members[this.oldIndex + 1].isActive = true;
    }

    // remove and store the first item in array
    const shifted = this.members.shift();
    // update the index
    shifted.index = this.members[this.members.length - 1].index + 1;
    // and append it
    this.members.push(shifted);

    if (_arrowClick || this.template_value === '3') { // || this.memberList.length > 7
      this.setTemplate(this.oldIndex + 1);
    } else {
      this.setTemplate(this.oldIndex + _increment);
    }
  }

  public prev(_arrowClick: boolean, _decrement?: number) {
    if (this.template_value != '3' && this.memberList.length <= 7) {
      this.oldIndex = undefined;
    }

    if (_arrowClick) {
      for (let i = 0; i < this.members.length; i++) {
        // find the active item
        if (this.memberList[i].classList.contains('active')) {
          // deactivate it
          this.memberList[i].classList.remove('active');
          // and store the index
          this.oldIndex = i;
        }
      }

      // deactivate previous
      this.members[this.oldIndex].isActive = false;
      // activate the selected
      this.members[this.oldIndex - 1].isActive = true;
    }

    // remove and store the last item in array
    const poped = this.members.pop();
    // update the index
    poped.index = this.members[0].index - 1;
    // and prepend it
    this.members.unshift(poped);

    if (_arrowClick || this.template_value === '3') {
      this.setTemplate(this.oldIndex - 1);
    } else { // if() {
      this.setTemplate(this.oldIndex - _decrement);
    }
  }

  private detectTemplate(_n: number) {
    // I've added this is because if the array is less than four none of the display logic works out correctly.
    // IT's a hack for now until a debugger can be brough to bare on the actual logic. - Tom R
    if (this.members.length <= 4) {
      return this.template_value = '1';
    }

    if (this.members.length == 3) {
      if (_n >= 768) {
        return this.template_value = '3';
      } else {
        return this.template_value = '1';
      }
    } else {
      if (_n >= 1200) {
        return this.template_value = '3';
      } else if (_n >= 768 && _n <= 1999) {
        return this.template_value = '3';
      } else {
        return this.template_value = '1';
      }
    }

  }

  private setTemplate(_oi: number) {

    if (this.template_value == '1') {

      this.hideAllMembers();
      this.memberList[_oi].classList.remove('hidden');

    } else if (this.template_value == '3' && this.memberList.length > 3) {

      this.hideAllMembers();

      this.memberList[_oi].classList.remove('hidden');
      this.memberList[_oi - 1].classList.remove('hidden');
      this.memberList[_oi + 1].classList.remove('hidden');

    } else if ((this.template_value == '3' && this.memberList.length == 3)) {
      this.showAllMembers();
    }
  }

  private hideAllMembers() {
    for (let i = 0; i < this.members.length; i++) {
      this.memberList[i].classList.add('hidden');
    }
  } // endOf - hideAllMembers

  private showAllMembers() {

    for (let i = 0; i < this.members.length; i++) {
      this.memberList[i].classList.remove('hidden');
    }

  } // endOf - hideAllMembers

}
